export default __webpack_public_path__ + "static/media/fb icon.4365dfc2.svg";